import React, { useEffect, useState, Fragment } from "react";
import { useDispatch } from "react-redux";

import Box from "@material-ui/core/Box";
import Fab from "@material-ui/core/Fab";
import CodeIcon from "@material-ui/icons/Code";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

import history from "../../../store/history";
import { DEV_API_DOC_DETAIL_GET_URL, DEV_API_DOC_DETAIL_EDIT_DATA_URL } from "../../../config";
import makeApiRequest from "../../../utils/axios/new-axios";
import { showErrorAlert } from "../../../store/actions/alerts";
import ComponentLoader from "../../../components/loader/ComponentLoader";
import { usePageTitle } from "../../../utils/pageTitle";
import NotFound from "../../NotFound";
import { permissions, types, checkAcl } from "../../../utils/acl";
import Redoc from "../../../components/api-doc/Redoc";
import ApiDocEditor from "../../../components/api-doc/ApiDocEditor";
import AsyncApi from "../../../components/api-doc/AsyncApi";


export default function ViewApiDoc(props) {
    const dispatch = useDispatch();
    const pageTitle = usePageTitle("View API");
    const EDIT_ACCESS = checkAcl({ p: permissions.DEV_SETTINGS, t: types.VIEW_AND_EDIT });

    const apiDocDetailId = props.match.params.apiDocDetailId;

    const [notFound, setNotFound] = useState(false);
    const [api, setApi] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [apiDocJson, setApiDocJson] = useState(null);

    const [openCodeEditor, setOpenCodeEditor] = useState(false);
    function handleOpenCodeEditorModal() {
        setOpenCodeEditor(true);
    }
    function handleCloseCodeEditorModal() {
        setOpenCodeEditor(false);
    }

    const getApiDocConfig = (doc) => {
        return doc.data.replace("AUTO_INSERT_SPEC_TYPE", doc.specType)
            .replace("AUTO_INSERT_SPEC_VERSION", doc.specVersion)
            .replace("AUTO_INSERT_NAME", doc.name)
            .replace("AUTO_INSERT_VERSION", doc.version)
            .replace("AUTO_INSERT_DESCRIPTION", doc.description)
            .replace("AUTO_INSERT_DEV_URL", doc.devUrl)
            .replace("AUTO_INSERT_LIVE_URL", doc.liveUrl);
    }

    useEffect(() => {
        makeApiRequest({
            url: `${DEV_API_DOC_DETAIL_GET_URL.url}/${apiDocDetailId}`,
            method: DEV_API_DOC_DETAIL_GET_URL.method,
        }).then(response => {
            setApi(response.data);
            setIsLoading(false);
            pageTitle(`API: ${response.data.name}`);

            if (response.data.data && response.data.apiDoc) {
                try {
                    const apiData = JSON.parse(response.data.data.replace("AUTO_INSERT_METHOD", response.data.method));
                    const apiDocData = JSON.parse(getApiDocConfig(response.data.apiDoc));
                    if (response.data.apiDoc.specType === "asyncapi") {
                        apiDocData.channels = {
                            [response.data.path]: apiData
                        };

                    } else {
                        apiDocData.paths = {
                            [response.data.path]: {
                                [response.data.method]: apiData
                            }
                        };
                    }
                    setApiDocJson(apiDocData);
                } catch (error) {
                    dispatch(showErrorAlert("Error parsing JSON : " + error.message));
                }

            }

        }).catch((error) => {
            setIsLoading(false);
            if (!!error.response && error.response.status === 404) {
                setNotFound(true);
            } else {
                dispatch(
                    showErrorAlert(
                        "API Detail Fetch Error : " +
                        (!!error.response
                            ? `${error.response.status}! - ${error.response.data.errorMessage}`
                            : error.message)
                    )
                );
            }
        })
        // eslint-disable-next-line
    }, []); // [] is required to make sure that it runs only once

    return (
        <Fragment>
            {!notFound ? (
                <div>
                    <ComponentLoader isLoading={isLoading} />

                    {!isLoading && api && (
                        <Fragment>
                            <Box style={{
                                position: "fixed",
                                right: 30,
                                top: 90,
                                zIndex: 99999
                            }}>
                                {!openCodeEditor &&
                                    <Fab
                                        size="small"
                                        aria-label="back"
                                        onClick={() => history.push(`/dev/api-docs/${api.apiDoc.id}`)}

                                    >
                                        <KeyboardBackspaceIcon />
                                    </Fab>}
                                {EDIT_ACCESS && !openCodeEditor &&
                                    <Fab
                                        size="small"
                                        color="secondary"
                                        aria-label="add"
                                        onClick={handleOpenCodeEditorModal}
                                        style={{ marginLeft: 10 }}
                                    >
                                        <CodeIcon />
                                    </Fab>}
                            </Box>
                            {api.apiDoc.specType === "asyncapi" ?
                                <AsyncApi spec={apiDocJson} /> : <Redoc spec={apiDocJson} />}

                        </Fragment>
                    )}
                </div>
            ) : (
                <NotFound />
            )}

            {api && EDIT_ACCESS && (
                <Fragment>
                    <ApiDocEditor
                        openModal={openCodeEditor}
                        handleCloseModal={handleCloseCodeEditorModal}
                        jsonString={api.data}
                        url={`${DEV_API_DOC_DETAIL_EDIT_DATA_URL.url}/${apiDocDetailId}`}
                        method={DEV_API_DOC_DETAIL_EDIT_DATA_URL.method}
                        returnUrl={window.location.pathname}
                        specType={api.apiDoc.specType}
                        dataWrapper={getApiDocConfig(api.apiDoc)}
                        dataWrapperPath={api.path}
                        dataWrapperMethod={api.method}
                    />

                </Fragment>
            )}
        </Fragment>
    )
}
